module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container service"
  }, [_c('com-title', {
    attrs: {
      "title": "推荐服务"
    }
  }), _vm._v(" "), _c('h4', [_vm._v("大咖面对面：与大会讲师深度交流")]), _vm._v(" "), _c('div', {
    staticClass: "word"
  }, [_vm._v("极客邦科技每年举办10+场全球性技术大会，拥有丰富的国内外讲师资源，助力企业IT技术团队人才职业发展和技能提升。如果您在大会上听讲师分享时间太短不过瘾，想要和大会讲师进行深度讨论，想要邀请大会讲师到企业内部做分享，可以随时联系我们的企业培训顾问，我们会根据您的企业需求，预约讲师并制定技术培训计划。\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-086ce667","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/consultation/com-service.vue
// module id = 436
// module chunks = 1